import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CheckSheetStatusComponent } from './check-sheet-status.component';

@NgModule({
  declarations: [CheckSheetStatusComponent],
  imports: [CommonModule],
  exports: [CheckSheetStatusComponent],
})
export class CheckSheetStatusModule {}
